import React, { Component } from 'react';

const SHADOW_CLASS = 'spreadsheet-layout__header--shadow';

// TODO: move in utils folder
function setVendor(element, property, value) {
	element.style['webkit' + property] = value;
	element.style['moz' + property] = value;
	element.style['ms' + property] = value;
	element.style['o' + property] = value;
}

class SpreadsheetLayout extends Component {
	componentDidMount() {
		/* Content margins computations*/
		const headerWidth = this.mainHeader.offsetWidth;
		const headerHeight = this.mainHeader.offsetHeight;

		this.columnsHeader.style.marginLeft = `${headerWidth}px`;
		this.rowsHeader.style.marginTop = `${headerHeight}px`;

		this.cells.style.marginTop = `${headerHeight}px`;
		this.cells.style.marginLeft = `${headerWidth}px`;
	}

	componentDidUpdate() {
		const { rowsNumber, columnsNumber } = this.props;

		const contentWidth = this.cells.offsetWidth;
		const contentHeight = this.cells.outerHeight;

		this.columnsHeader.style.width = `${contentWidth}px`;
		this.rowsHeader.style.height = `${rowsNumber * 50}px`;
	}

	render() {
		const {
			header,
			columnsHeader,
			rowsHeader,
			content,
			floatingButton,
			buttons
		} = this.props;

		return (
			<div
				className="spreadsheet-layout"
				ref={el => (this.spreadsheetEl = el)}
				onScroll={this.handleScroll}
			>
				<header
					className="spreadsheet-layout__header spreadsheet-layout__header--main"
					ref={el => (this.mainHeader = el)}
				>
					{header}
					<div className="spreadsheet-layout__floating-button">
						{floatingButton}
					</div>
				</header>
				<div
					className="spreadsheet-layout__header"
					ref={el => (this.columnsHeader = el)}
				>
					{columnsHeader}
				</div>
				<div
					className="spreadsheet-layout__header"
					ref={el => (this.rowsHeader = el)}
				>
					{rowsHeader}
				</div>
				<div ref={el => (this.cells = el)}>
					{this.renderCells()}
					{content}
				</div>
				<div className="spreadsheet-layout__buttons">{buttons}</div>
			</div>
		);
	}

	renderCells = () => {
		const {
			rowsNumber,
			columnsNumber,
			renderCell = () => null
		} = this.props;

		const rows = [];
		for (let i = 0; i < rowsNumber; i++) {
			const cells = [];
			for (let j = 0; j < columnsNumber; j++) {
				cells.push(
					<div key={j} className="spreadsheet-layout__cell">
						{renderCell(i, j)}
					</div>
				);
			}
			rows.push(
				<div key={i} className="spreadsheet-layout__row">
					{cells}
				</div>
			);
		}

		return rows;
	};

	handleScroll = event => {
		event.preventDefault();

		const { scrollTop, scrollLeft } = this.spreadsheetEl;

		/* Header transformation */
		this.translateEl(this.mainHeader, scrollTop, scrollLeft);

		/* Top element transformations */
		this.translateEl(this.columnsHeader, scrollTop, 0);
		this.setShadow(this.columnsHeader, scrollTop);

		/* Left element transformations */
		this.translateEl(this.rowsHeader, 0, scrollLeft);
		this.setShadow(this.rowsHeader, scrollLeft);
	};

	translateEl = (el, top, left) => {
		setVendor(el, 'Transform', `translate(${left}px, ${top}px)`);
	};

	setShadow = (el, scroll) => {
		const hasShadow = el.classList.contains(SHADOW_CLASS);

		if (!hasShadow && scroll > 5) {
			el.classList.add(SHADOW_CLASS);
		}

		if (scroll < 5) {
			el.classList.remove(SHADOW_CLASS);
		}
	};
}

const DefaultHeader = (
	<div className="spreadsheet-layout__default-header">Default header</div>
);

const DefaultColumnsHeader = (
	<div className="spreadsheet-layout__default-columns-header">
		Default colmuns header
	</div>
);

const DefaultRowsHeader = (
	<div className="spreadsheet-layout__default-rows-header">
		Default rows header
	</div>
);

const DefaultFloatingButton = (
	<button className="spreadsheet-layout__default-floating-button">DFB</button>
);

const DefaultButtons = (
	<div className="spreadsheet-layout__default-buttons">Default buttons</div>
);

SpreadsheetLayout.defaultProps = {
	rowsNumber: 20,
	columnsNumber: 20,
	header: DefaultHeader,
	columnsHeader: DefaultColumnsHeader,
	rowsHeader: DefaultRowsHeader,
	floatingButton: DefaultFloatingButton,
	buttons: DefaultButtons
};

export default SpreadsheetLayout;



// WEBPACK FOOTER //
// ./src/js/PatternDuplication/SpreadsheetLayout/SpreadsheetLayout.js